import { DashboardResources } from '@src/types';
import {
  Toolbar,
  SaveButton,
  CanAccess,
} from 'react-admin';
import { Box } from '@mui/material';
import type { VariantSaveRef } from './VariantDetailPanel';

interface CatalogEditToolbarProps {
  variantSaveRef?: VariantSaveRef;
}

const CatalogEditToolbar = ({ variantSaveRef }: CatalogEditToolbarProps) => (
  <Toolbar>
    <CanAccess resource={DashboardResources.CatalogItems} action="edit">
      <Box
        component="span"
        onClickCapture={(e: React.MouseEvent) => {
          if (variantSaveRef?.current) {
            e.stopPropagation();
            void variantSaveRef.current();
          }
        }}
      >
        <SaveButton />
      </Box>
    </CanAccess>
  </Toolbar>
);

export default CatalogEditToolbar;
